import { useCallback, useMemo, memo } from 'react';
import type { CampaignSource } from 'features/campaigns';
import type { CampaignDataAttributes } from '../../../../hooks/styling/useCampaignDataAttributes';
import { useCampaignTypeContext } from 'features/campaigns';
import { campaignMapper } from 'features/campaigns/services/campaignCardService';
import CampaignCard from '../../CampaignCard/CampaignCard';
import campaignsCarouselStyles from '../css/CampaignsCarousel.module.css';

interface CarouselItemProps {
  campaign: CampaignSource;
  isActive: boolean;
  side?: string;
  onSelect: (campaign: CampaignSource) => void;
  dataAttributes: CampaignDataAttributes;
  registerRef?: (el: HTMLElement | null) => void;
}

const CarouselItem: React.FC<CarouselItemProps> = ({
  campaign,
  isActive,
  side,
  onSelect,
  dataAttributes,
  registerRef
}) => {
  const campaignType = useCampaignTypeContext();
  const mappedCampaign = useMemo(
    () => (campaignType ? campaignMapper(campaignType, [campaign]) : null),
    [campaignType, campaign]
  );

  const handleClick = useCallback(() => onSelect(campaign), [onSelect, campaign]);

  if (!mappedCampaign) return null;

  return (
    <div
      ref={registerRef}
      className={campaignsCarouselStyles.carouselItem}
      data-campaign-id={campaign.id}
      {...dataAttributes}
    >
      <div
        className={campaignsCarouselStyles.cardContent}
        data-active={isActive ? 'true' : 'false'}
        data-side={side}
      >
        <CampaignCard
          campaignInfo={{ ...mappedCampaign.campaignInfo, campaignId: campaign.id }}
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default memo(CarouselItem);
